import cx from 'classnames';
import styles from './styles.module.scss';
import { useEffect, useMemo, useState } from 'react';
import { icons } from '../../../assets';
import UpgradeCardBanner from './UpgradeCardBanner';
import useCurrentOrganizationInfo from '../../../hooks/useCurrentOrganizationInfo';
import { isTextureProductPage } from '../../../helpers/jsHelper';
import { GetProductShareStatus, GetTextureShareStatus, MakeProductPublicShare, MakeTexturePublicShare, UpdateProductPublicShare, UpdateTexturePublicShare, apiCreatePublicUUID, apiCreatePublicUUIDTexture, apiGetProductCategoryConfigurator, apiGetProductCategoryVideo, apiGetPublicUUID, apiGetPublicUUIDTexture, apiGetTextureCategoryConfigurator, apiGetTextureCategoryVideo } from '../../../helpers/api';
import { selectPublicLinkData, setSharePublicLinkData } from '../../../redux/slicers/productV2Slicer';
import { useDispatch, useSelector } from 'react-redux';
import { handleCopyURL } from '../../../common/SharePopup';
import { useCopyToClipboard } from 'react-use';
import { useUserContext } from '../../../contexts/UserContext';
import { ShareModalButton } from '../ShareButtonV2/shareModalbtn';
import { Loader } from '../../../common';
import { PRODUCT_CATEGORY, STATUS_DONE_KEY } from '../../../constants/constants';
const { ArrowIconV2, LockIcon, CopyLinkIcon, CodeIcon } = icons;

const { THREEDVIEWER, ARVIEWER, THREESIXTY, VIDEO, CONFIGURATOR } = PRODUCT_CATEGORY;

export const EmbedAndCopy = ({ setShowEmbedCodeView = null, className = '', product = null , isDisabled = false , trackingEnable = false }) => {
  const dispatch = useDispatch();
  const [state, copy] = useCopyToClipboard();
  const [shareAPIData, setShareAPIData] = useState(null);
  const [productUnicode, setProductUnicode] = useState(null);
  const isTexture = isTextureProductPage()
  const productId  = product?.id || null;
  

  const onCopy = () => {
    handleCopyURL({ productId, productUnicode, isV2:true, isTexture, copy , trackingEnable })
  };

  useEffect(() => {
    const fetchShareStatus = async () => {
      if (productId) {
        const getFunc = isTexture ? GetTextureShareStatus : GetProductShareStatus;
        const res = await getFunc(productId);
        if (res?.results?.length) {
          publicShareAPI(res);
        } else {
          handleToggleChange();
        }
      } else {
        window.$shareItem = null;
        window.$shareFlag = false;
      }
    };
  
    fetchShareStatus();
  }, [productId, isTexture]);  // Added `productId` in dependencies
  

  const publicShareAPI = async (res) => {
    setShareAPIData(res?.results[0] || null);
    window.$shareItem = res?.results?.[0];
    window.$shareFlag = res?.results?.[0]?.is_public;
    if (res?.results[0]?.is_public) {
      const getPublicUUID = isTexture ? apiGetPublicUUIDTexture : apiGetPublicUUID;
      const response = await getPublicUUID(
        `?${isTexture ? 'texture' : 'product'}=${productId}`
      );
      if (response?.results?.length) {
        setProductUnicode(response.results[0]?.unique_code);
        dispatch(setSharePublicLinkData(response.results[0]))
        window.$shareItem.unique_code = response?.data?.unique_code;
      } else {
        const formData = new FormData();
        formData.append(isTexture ? 'texture' : 'product', productId);
        const createFunc = isTexture ? apiCreatePublicUUIDTexture : apiCreatePublicUUID;
        const response = await createFunc(formData);
        if (response?.status) {
          setProductUnicode(response?.data?.unique_code);
          dispatch(setSharePublicLinkData(response?.data))
          window.$shareItem.unique_code = response?.data?.unique_code;
        }
      }
  }else{
    handleToggleChange(res?.results[0])
  }
}

  // update product sharing status like public or non-public
  const handleToggleChange = async (data = shareAPIData) => {
    if (productId) {
      const payload = {
        [isTexture ? 'texture' : 'product']: productId,
        is_publish: true,
        is_public: true,
      };
      let res = null;
      if (data && Object.keys(data)?.length) {
        const updateFunc = isTexture ? UpdateTexturePublicShare : UpdateProductPublicShare;
        res = await updateFunc(payload);
      } else {
        const makeFunc = isTexture ? MakeTexturePublicShare : MakeProductPublicShare;
        res = await makeFunc(payload);
      }
      if (res?.status && res?.data) {
        window.$shareItem = res?.data;
        window.$shareFlag = res?.data?.is_public;
        setShareAPIData(res?.data);
        const getFunc = isTexture ? apiGetPublicUUIDTexture : apiGetPublicUUID;
        const response = await getFunc(`?${isTexture ? 'texture' : 'product'}=${productId}`);
        if (response?.results?.length) {
          setProductUnicode(response.results[0]?.unique_code);
          dispatch(setSharePublicLinkData(response.results[0]))
          window.$shareItem.unique_code = response?.data?.unique_code;
        } else {
          const formData = new FormData();
          formData.append(isTexture ? 'texture' : 'product', productId);
          const createFunc = isTexture ? apiCreatePublicUUIDTexture : apiCreatePublicUUID;
          const response = await createFunc(formData);
          if (response?.status) {
            setProductUnicode(response?.data?.unique_code);
            dispatch(setSharePublicLinkData(response.data))
            window.$shareItem.unique_code = response?.data?.unique_code;
          }
        }
      } else {
        window.$shareItem = null;
        window.$shareFlag = false;
        setProductUnicode(null);
      }
    }
  };

  return (
    <div className={cx(styles.container, className)}>
      <h2 className={styles.heading}>EMBED</h2>
      <div
        className={cx(styles.menuLabel, isDisabled ? styles.disableEvent : 'cursor-pointer')}
        onClick={() => !isDisabled && setShowEmbedCodeView?.(true)}>
        <div className="d-flex align-items-center gap-2">
          <LockIcon />
          <span>Get embed code</span>
        </div>
        <ArrowIconV2 className={cx(styles.arrowIcon, styles.dirRight)} />
      </div>
      <div className="w-100 d-flex align-items-center justify-content-between">
        <span className={styles.infoText}>
          To enable embedding, you must set the file’s access to “Anyone with the link” (View Only) in the sharing settings.
        </span>
        <button className={styles.copyBtn} onClick={onCopy}>
          <CopyLinkIcon />
          <span>Copy link</span>
        </button>
      </div>
    </div>
  );
};

export const EmbedCode = ({ product, className = '' , showEmbedCodeView, trackingEnable = false }) => {
  const { isFreemiumUser } = useCurrentOrganizationInfo();
  const { currentUser } = useUserContext();
  const publicLinkData = useSelector(selectPublicLinkData);
  const [state, copy] = useCopyToClipboard();
  const isTexture = isTextureProductPage()
  const [embedLink, setEmbedLink] = useState(null);
  const [loader, setLoader] = useState(null);
  const [checked, setChecked] = useState(() => ({
    [THREEDVIEWER]: false,
    [THREESIXTY]: false,
    [CONFIGURATOR]: false,
    ...(!isTexture ? { [ARVIEWER]: false } : {}),
    [VIDEO]: false,
  }));
  const [data, setData] = useState(() => ({
    [THREEDVIEWER]: true,
    [THREESIXTY]: true,
    [CONFIGURATOR]: [],
    [ARVIEWER]: true,
    [VIDEO]: [],
  }));
  const [isConfigurator, setIsConfigurator] = useState(false);
  const [refreshPage, setRefreshPage] = useState(0);
  const productId  = product?.id || null;
  const productUnicode = publicLinkData?.unique_code
  const type = isTexture ? "texture" : "product"
  const currentOrg = productUnicode || currentUser?.organization;

  const getProductVideo = async () => {
    const payload = {
      id:productId,
      params:{is_archive:false, show_on_page:true, [type]:productId},
      page:1,
      per_page:50,
    }
    const APIFun = isTexture ? apiGetTextureCategoryVideo : apiGetProductCategoryVideo
    const res = await APIFun(payload)
    setData({...data, [VIDEO]:res?.results || []})
  }

  const getProductConfiguratorData = async () => {
    const payload = {
      id:productId,
      params:{is_archive:false, show_on_page:true, [type]:productId , sort:"is_archive,order"},
      page:1,
      per_page:20,
    }
    const APIFun = isTexture ? apiGetTextureCategoryConfigurator : apiGetProductCategoryConfigurator
    const res = await APIFun(payload)
    setIsConfigurator(res?.results?.length ? res?.results : false)
  }

  useEffect(()=> {
    if(showEmbedCodeView){
      setLoader(true)
      setTimeout(() => {
        setLoader(false)
      }, 2500);
      if(!data[VIDEO]?.length){
        getProductVideo()
      }
      if(!isConfigurator){
        getProductConfiguratorData()
      }
    }
    return () => {
      setLoader(false)
    }
  },[showEmbedCodeView])

useEffect(()=> {
    if(productUnicode && !embedLink){
      setEmbedLink(handleCopyURL({
        productId,
        productUnicode,
        isV2:true,
        isTexture,
        isEmbed: true,
        copy:() => {},
        disableCopy:false,
        showMessage:false,
        isFrameCode:true
      }))
    }
  },[productUnicode])

  const onToggle = (e, type = null) => { 
    if (!type) return;
    e?.stopPropagation();
    setChecked((prev) => ({ ...prev, [type]: !checked[type] }));
    // TODO: integrate a code for enabling/disabling the embed code
  };

  const onCopy = () => {
    handleCopyURL({
      productId,
      productUnicode,
      isV2:true,
      isTexture,
      isEmbed: true,
      copy,
      trackingEnable:trackingEnable
    })
  
  };

  const EmbedList = useMemo(
    () => [
      {
        id: 1,
        title: 'Embed 3D Viewer',
        type: THREEDVIEWER,
        checked: checked?.THREEDVIEWER,
        disabled: +product?.generate_images_content_status !== STATUS_DONE_KEY,
        hide: false,
      },
      {
        id: 2,
        title: 'Embed Augmented Reality',
        type: ARVIEWER,
        checked: checked?.ARVIEWER,
        disabled: +product?.generate_ar_content_status !== STATUS_DONE_KEY,
        hide: isTexture, // hiding for 'Texture' as it is not available in it
      },
      {
        id: 3,
        title: 'Embed 360 Spinner',
        type: THREESIXTY,
        checked: checked?.THREESIXTY,
        disabled: +product?.generate_360_content_status !== STATUS_DONE_KEY,
        hide: false,
      },
      {
        id: 5,
        title: 'Embed Configurator',
        type: CONFIGURATOR,
        checked: checked?.CONFIGURATOR,
        disabled: false,
        hide: false,
      },
      {
        id: 4,
        title: 'Embed Video',
        type: VIDEO,
        checked: checked?.VIDEO,
        disabled: false,
        hide: false,
      },
    ],
    [[product, checked]]
  );

  if(!showEmbedCodeView){
    return null
  }

  return (
    <div className={cx(styles.container, className, 'mt-3 gap-1')}>
      {loader &&  <Loader position="absolute" style={{backgroundColor: "#ffffff99"}} loading={true} />}
      {embedLink && <div className={cx(styles.codeView, 'mb-3')}>
        <pre>
          <code>
            {`${embedLink}`}
          </code>
        </pre>
       </div>
      }
      {EmbedList.filter((a) => !a.hide).map((item) => (
        <div
          key={item.id}
          className={`w-100 d-flex ${item?.type === VIDEO ? "flex-column" : ""} align-items-center justify-content-between gap-3 mr-1 pr-2 mt-1 mb-1`}>
          {item?.type === VIDEO || item?.type === CONFIGURATOR ? <>
          {
           item?.type === VIDEO && data[VIDEO]?.length > 0 ? <>
            {
              data[VIDEO]?.map((list , idx)=> {
                return <>
                <div className='d-flex w-100 justify-content-between'>
                <span>{item?.title} : {list?.video_details?.name || list?.aivideo_details?.name}</span>
              <ShareModalButton
              category={item?.type}
              isPublicPage={false}
              isPackProduct={window.$isPackProduct}
              productId={productId}
              productInfo={product}
              productUnicodeId={product?.unicode}
              orgProductUniqueCodeId={productUnicode}
              selectedItem={{...product , ...list}}
              currentOrg={currentOrg}
              isTexture={isTexture}
              onToggle={(e) => onToggle(e, item.type)}
              checked={item.checked}
              disabled={item.disabled}
              videoObjectId={list?.video_details?.id || list?.aivideo_details?.id}
            />
              </div> 
                </>
              })
            }
            </> : null
          }
          {
            item?.type === CONFIGURATOR && isConfigurator && <>
            <span>{item.title}</span>
           <ShareModalButton
              category={item?.type}
              isPublicPage={false}
              isPackProduct={window.$isPackProduct}
              productId={productId}
              productInfo={product}
              productUnicodeId={product?.unicode}
              orgProductUniqueCodeId={productUnicode}
              selectedItem={product}
              currentOrg={currentOrg}
              isTexture={isTexture}
              onToggle={(e) => onToggle(e, item.type)}
              checked={item.checked}
              disabled={item.disabled}
              configuratorUniqueId={isConfigurator?.[0]?.configurator_details?.unique_id}
            />
            </>
          }
          </> : <>
          <span>{item.title}</span>
           <ShareModalButton
              category={item?.type}
              isPublicPage={false}
              isPackProduct={window.$isPackProduct}
              productId={productId}
              productInfo={product}
              productUnicodeId={product?.unicode}
              orgProductUniqueCodeId={productUnicode}
              selectedItem={product}
              currentOrg={currentOrg}
              isTexture={isTexture}
              onToggle={(e) => onToggle(e, item.type)}
              checked={item.checked}
              disabled={item.disabled}
              setRefreshPage={setRefreshPage}
              refreshPage={refreshPage}
            />
          </>}  
        </div>
      ))}
      {isFreemiumUser && <UpgradeCardBanner title="Upgrade now to enable embed for your product page." description='' />}
      <div className="w-100 d-flex align-items-center justify-content-end mt-3">
        <button className={styles.copyBtn} onClick={onCopy}>
          <CodeIcon />
          <span>Copy embed code</span>
        </button>
      </div>
    </div>
  );
};
